<template>
  <v-chip
    :color="tag.color"
    small
    :close="removable"
    @click:close="$emit(`remove`, tag)"
    class="my-1 mx-1 tag-chip"
    :style="{ color: tag.fontColor }"
    :key="tag.id"
  >
    {{ tag.label }}
  </v-chip>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      required: true,
    },
    removable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  .v-chip.tag-chip {
    &:first-child {
      margin-left: 0px !important;
    }
    &:last-child {
      margin-right: 0px !important;
    }
  }
</style>
